module.exports = __webpack_public_path__ + "static/media/banano.498befd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/banano.svg
// module id = 1030
// module chunks = 389